/* ============================================================
   blog-editorial.js — enhancement for the editorial article template.
   Dependency-free, defer-safe, scoped to .sn-article. Everything degrades
   gracefully: with JS off you still get readable prose, a working FAQ
   (<details>), and any rendered components — just no progress bar / live TOC.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('.sn-article');
  if (!root) return;

  /* ---------- Reading progress ---------- */
  var bar = root.querySelector('[data-progress-bar]');
  if (bar) {
    var onScroll = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Build the TOC from the article's H2s ---------- */
  var slugify = function (s) {
    return s.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  };
  var prose = root.querySelector('.prose');
  var tocNav = root.querySelector('[data-toc]');
  var heads = prose ? [].slice.call(prose.querySelectorAll('h2')) : [];
  var links = [];
  var sections = [];

  if (tocNav && heads.length) {
    var ol = document.createElement('ol');
    var seen = {};
    heads.forEach(function (h) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        if (seen[id]) id = id + '-' + (++seen[id]);
        else seen[id] = 1;
        h.id = id;
      }
      h.style.scrollMarginTop = '88px';
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(id);
        if (t) { window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 84, behavior: 'smooth' }); }
        history.replaceState(null, '', '#' + id);
      });
      li.appendChild(a);
      ol.appendChild(li);
      links.push(a);
      sections.push(h);
    });
    tocNav.appendChild(ol);
    tocNav.hidden = false;

    /* ---------- Scroll-spy ---------- */
    var spy = function () {
      var idx = 0;
      sections.forEach(function (s, i) { if (s.getBoundingClientRect().top <= 120) idx = i; });
      links.forEach(function (l) { l.classList.remove('active'); });
      if (links[idx]) links[idx].classList.add('active');
    };
    document.addEventListener('scroll', spy, { passive: true });
    spy();
  }

  /* ---------- Interactive tooth explorer (teeth-diagram post) ---------- */
  [].slice.call(root.querySelectorAll('[data-tooth-explorer]')).forEach(function (ex) {
    var tabs = ex.querySelector('[data-te-tabs]');
    if (!tabs) return;
    var set = function (key, sel) { var el = ex.querySelector(sel); if (el) el.textContent = key; };
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.te-tab');
      if (!tab) return;
      [].slice.call(tabs.children).forEach(function (t) { t.classList.remove('on'); });
      tab.classList.add('on');
      var d = tab.dataset;
      set(d.count, '[data-te-big]');
      set(d.where, '[data-te-where]');
      set(d.title, '[data-te-title]');
      set(d.job, '[data-te-job]');
      set(d.watch, '[data-te-watch]');
    });
  });

  /* ---------- Dental Health Checker (one or many on a page) ---------- */
  [].slice.call(root.querySelectorAll('[data-checker]')).forEach(function (checker) {
    var opts = checker.querySelector('[data-ck-opts]');
    var result = checker.querySelector('[data-ck-result]');
    var text = checker.querySelector('[data-ck-text]');
    if (!opts || !result || !text) return;
    opts.addEventListener('click', function (e) {
      var btn = e.target.closest('.ck-opt');
      if (!btn) return;
      [].slice.call(opts.children).forEach(function (b) { b.classList.remove('sel'); });
      btn.classList.add('sel');
      var r = btn.getAttribute('data-r') || '';
      var warn = r.indexOf('warn|') === 0;
      if (warn) r = r.slice(5);
      result.classList.toggle('warn', warn);
      text.textContent = r;
    });
  });
})();
